
/**
 * 菜单
 * wangj
 */


const SgiMenuEO = function () {

    return {
        // autoHide: false,
        // docket: "top",//停靠位置，现在支持垂直、水平、和内嵌模式三种
        // indented: true,
        // ignoreParentClicks: false,
        // otherMenus: false,
        // plain: false,
        // flx: 0,
        // separator: false,
        // mouseLeaveDelay: 50,
        // ctlH: "",
        // ctlW: "",
        desId: "EP_EO_UI_4004",
        // rSC:"SD_SC_PUB_test1",//下拉窗列表值在标准代码中的id
        // cldSet:'',//
        mode:'inline',//菜单类型，现在支持垂直、水平、和内嵌模式三种
        // sNo: 0,
        // ann:'',//
        c:'',//
        ctlN: "菜单",
        cId:'',//组件编号
        // sc:'',//语义代码
        n: "菜单",
        // t: "text",
        te: "我是菜单组件x",
        // teAl: "left",
        
        theme: "light",
        insName: "",//绑定实例名-y
        // inlineCollapsed: "",//inline 时菜单是否收起状态
    }

}

export { SgiMenuEO };
export default SgiMenuEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiMenuEO.js